import { useRecoilValue } from "recoil";
import { remoteDateState } from "./store/RemoteDateState";

function RemoteDateSynchronizer({children}) {
	useRecoilValue(remoteDateState);
	return children || null;
}

export default RemoteDateSynchronizer;
